export default "__VITE_ASSET__Dq6TTM3s__"